import { render, staticRenderFns } from "./Tabela.vue?vue&type=template&id=43f32769&scoped=true&lang=pug"
import script from "./Tabela.vue?vue&type=script&lang=js"
export * from "./Tabela.vue?vue&type=script&lang=js"
import style0 from "./Tabela.styl?vue&type=style&index=0&id=43f32769&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f32769",
  null
  
)

export default component.exports